export default "__VITE_ASSET__lKkWZYpv__"